module.exports = __webpack_public_path__ + "img/green1.3df35bf4.jpg";